<template>
  <el-dialog
    :title="modelWord"
    :visible.sync="editDialogVisible"
    width="1100px"
    :before-close="closeBtn"
  >
    <el-form
      :model="editform"
      ref="editform"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        label="反馈类别："
        prop="categoryName"
      >
        {{editform.categoryName}}
      </el-form-item>
      <el-form-item
        label="反馈姓名："
        prop="fkName"
      >
        {{editform.fkName}}
      </el-form-item>
      <el-form-item
        label="反馈手机号："
        prop="phone"
      >
        {{editform.phone}}
      </el-form-item>
      <!-- <el-form-item v-if='modelWord =="处理"' label="处理时效：" prop="processTime">
				{{editform.complaintsRecord.processTime}}
			</el-form-item> -->
      <el-form-item
        label="投诉标题："
        prop="title"
      >
        {{editform.title}}
      </el-form-item>
      <el-form-item
        label="投诉内容："
        prop="content"
      >
        {{editform.content}}
      </el-form-item>
      <el-form-item label="图片：">
        <div class="threestyleimg">
          <div class="threestyleimgtu">
            <!--						<img :src="upimgfabuurl" alt style="width:170px;height:150px" />-->
            <img
              v-for="(item,index) in editform.imgList"
              :key="index"
              :src="item"
              alt
              style="width:170px;height:150px"
            />

          </div>
          <!-- <div class="threestyleimgbtn">
						<div>上传照片</div>
						<input type="file" @change="upimgfabu" />
					</div> -->
        </div>
      </el-form-item>
      <!-- <el-form-item label="对象：" prop="targer">
				{{editform.targer}}
			</el-form-item> -->
      <el-form-item
        v-if='modelWord =="处理"'
        label="处理或解决方案："
        prop="processPlan"
      >
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          style="width: 200px;"
          v-model="editform.complaintsRecord.processPlan"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        v-if='modelWord =="处理"'
        label="处理部门："
        prop="processBranch"
      >
        <el-input
          v-model="editform.complaintsRecord.processBranch"
          placeholder="请输入部门"
          style="width:200px"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="modelWord =='处理'?'处理人:':'处理人:'"
        prop="processName"
      >
        <el-input
          v-model="editform.complaintsRecord.processName"
          placeholder="请输入处理人"
          style="width:200px"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if='modelWord =="查看"'
        label="处理日期："
        prop="processDate"
      >
        <el-date-picker
          v-model="editform.complaintsRecord.processDate"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        v-if='modelWord =="转批"'
        label="处理时效："
        prop="processTime"
      >
        <el-date-picker
          v-model="editform.complaintsRecord.processTime"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="boontbtn">
      <el-button
        type="primary"
        size="small"
        style="margin: 0 30px"
        @click="save"
        v-if='modelWord =="处理" || modelWord=="转批"'
      >保存</el-button>
      <el-button
        type="info"
        size="small"
        @click="closeBtn"
      >取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  findComplaintsById,
  dealComplaints,
  turnComplaints,
} from "@/api/requrestHttp.js"
import { post } from "../../api/requrestHttp"
import request from "../../utils/request"
export default {
  props: {
    editDialogVisible: {
      type: Boolean,
      default: false,
    },
    modelWord: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editform: {
        complaintsRecord: {
          processTime: "",
          processBranch: "",
          processName: "",
          processDate: "",
        },
      },
      newupimgfabuurl: "",
      upimgfabuurl: require("@/assets/images/partyMemberManagementcopy/imgjia.png"),
      userOptions: [],
      orgTree: [],
    }
  },
  methods: {
    //获取人员
    getUser(value) {
      this.userOptions = []
      console.log(this.editform.complaintsRecord.orgId)
      post("/admin/user/info/list", {
        orgId: this.editform.complaintsRecord.orgId[
          this.editform.complaintsRecord.orgId.length - 1
        ],
        pageNo: 1,
        pageSize: 99,
      }).then((res) => {
        res.content.list.forEach((e) => {
          this.userOptions.push({
            value: e.id,
            label: e.name,
          })
        })
      })
    },
    //获取组织机构树
    async getOrgsTree() {
      this.selectOrgs = []
      var res = await request({
        url: "/rbac/admin/org/info/OrgTreelist",
        method: "POST",
        data: { threeType: 1,isValid: 1, },
      })
      //  console.log(res)
      if (res.content.length > 0) {
        res.content.forEach((item) => {
          var children = []
          if (item.children != null && item.children.length > 0) {
            children = this.formateTree(item.children)
          }
          this.selectOrgs.push({
            id: item.orgId,
            value: item.orgId,
            label: item.label,
            children: children,
          })
        })
      }
    },

    async getDetail(id) {
      let res = await findComplaintsById({
        id,
      })
      if (res.code == 200) {
        if (res.content.category == 0) {
          res.content.categoryName = "投诉"
        }
        if (res.content.category == 1) {
          res.content.categoryName = "建议"
        }
        if (res.content.complaintsRecord) {
          this.editform = res.content
          let imgList = []
          res.content.imgPath.split(",").forEach((item) => {
            imgList.push(item)
          })
          this.editform.imgList = imgList
        } else {
          res.content.complaintsRecord = {
            processTime: "",
            processBranch: "",
            processName: "",
            processDate: "",
          }
          this.editform = res.content
          let imgList = []
          res.content.imgPath.split(",").forEach((item) => {
            imgList.push(item)
          })
          this.editform.imgList = imgList
        }
      } else {
        this.$message({
          message: res.message,
          type: "error",
        })
      }
    },
    closeBtn() {
      this.$emit("closeBtn", false)
    },
    async save() {
      let res
      let data = {
        complaintsId: String(this.editform.id),
        processName: this.editform.complaintsRecord.processName,
        status: this.editform.status,
      }
      if (this.modelWord == "处理") {
        data.processPlan = this.editform.complaintsRecord.processPlan
        data.processBranch = this.editform.complaintsRecord.processBranch
        data.processDate = this.editform.complaintsRecord.processDate
        data.status = 3
        res = await dealComplaints(data)
        if (res.code == 200) {
          let cen =
            this.editform.fkName +
            "，您在新庄孜街道的投诉或建议已经处理，请前往新庄孜街道智慧社区公众号查看"
          post("/admin/complaints/info/sends", {
            linkPhone: this.editform.phone,
            content: cen,
          }).then((res) => {
            this.$message({
              message: "短信发送成功",
              type: "success",
            })
          })
        }
      } else if (this.modelWord == "转批") {
        data.processTime = this.editform.complaintsRecord.processTime
        data.status = 1
        res = await turnComplaints(data)
      }
      if (res.code == 200) {
        this.$message({
          message: res.message,
          type: "success",
        })
        this.$emit("define")
        this.closeBtn()
      } else {
        this.$message({
          message: res.message,
          type: "error",
        })
      }
    },
  },
  mounted() {
    this.getOrgsTree()
    post("/rbac/admin/org/info/OrgTreelist", {
      orgType: "",isValid: 1,
    }).then((res) => {
      this.orgTree = res.content
    })
  },
}
</script>

<style lang="less" scoped="scoped">
</style>
